import { Box, makeStyles, Typography } from '@material-ui/core';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';

import { FontSizes } from '../../../../core/config/mainTheme';

export interface CountProps {
  boxTitle: string;
  totalCount?: number;
  count?: number;
  selectedCount?: number;
}

const CountBox: React.FC<CountProps> = ({ boxTitle, totalCount, count, selectedCount }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.countBox}>
      <Typography className={classes.count}>
        {typeof totalCount === 'number' && (
          <NumberFormat value={totalCount} displayType={'text'} thousandSeparator={true} />
        )}
      </Typography>
      <Typography> {t(boxTitle)}</Typography>
      {typeof selectedCount === 'number' && selectedCount > 0 ? (
        <>
          <Typography className={classes.selectedBoxSpace}>(</Typography>
          <Typography className={classes.count}>
            <NumberFormat value={selectedCount} displayType={'text'} thousandSeparator={true} />
          </Typography>
          <Typography>{t('app:datagrid:selected')})</Typography>
        </>
      ) : null}
      {totalCount && count && totalCount > count ? (
        <Typography className={classes.displayedText}>
          <ReportProblemIcon />
          <Trans i18nKey={'companies:displayedCountResults'} count={count} />
        </Typography>
      ) : null}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  countBox: {
    display: 'flex',
    fontSize: FontSizes.size.headerSize,
    alignItems: 'center',
    '& .MuiTypography-root': {
      lineHeight: 1,
    },
    height: '44px',
  },
  count: {
    fontSize: FontSizes.size.headerSize,
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
  },
  selectedBoxSpace: {
    marginLeft: theme.spacing(4),
  },
  displayedText: {
    marginLeft: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    fontSize: FontSizes.size.normal,
    marginTop: theme.spacing(1),
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: FontSizes.size.headerSize,
      marginBottom: theme.spacing(2),
    },
  },
}));

export default CountBox;
